// @file Helper functions for surface comments
import { CommentDraftState } from '@@/enums'
import type { CommentDraft } from '@@/types/surface_comments'
import { uniqueId } from 'es-toolkit/compat'

const addCommentCidIfAbsent = (comment) => {
  if (comment.cid) return comment
  if (comment.id != null) return { ...comment, cid: `comment_${comment.id}` }
  return { ...comment, cid: uniqueId('comment_new_') }
}

// Creates a new comment draft with default attributes.
const newCommentDraft = (attributes: Partial<CommentDraft>): CommentDraft => {
  return addCommentCidIfAbsent({
    draftState: CommentDraftState.Writing,
    ...attributes,
  })
}

export { addCommentCidIfAbsent, newCommentDraft }
